var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona",
    transform: "translate(-1929 -4263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book",
    transform: "translate(1865.098 4263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1867",
    "data-name": "Tracciato 1867",
    d: "M151.946,62.088V58.679h-7.028v3.409h7.028ZM145.47,59.14h5.925v2.488H145.47Z",
    transform: "translate(-77.072 -56.877)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_760",
    "data-name": "Rettangolo 760",
    width: 4.746,
    height: 0.461,
    transform: "translate(68.987 2.749)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_761",
    "data-name": "Rettangolo 761",
    width: 4.746,
    height: 0.461,
    transform: "translate(68.987 3.67)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1868",
    "data-name": "Tracciato 1868",
    d: "M76.9,0H66.349A1.345,1.345,0,0,0,64.9,1.207V11.417a1.345,1.345,0,0,0,1.447,1.207h.843V14h2.056V12.624H76.9ZM76.35,10.209H66.625V.461H76.35ZM66.073.5v9.734a1.576,1.576,0,0,0-.619.237V1.207A.776.776,0,0,1,66.073.5Zm.276,11.666a.832.832,0,0,1-.895-.747.686.686,0,0,1,.262-.528.985.985,0,0,1,.633-.219h.843v1.494Zm1.395,1.376V10.67H68.7v2.87h-.953Zm8.607-1.376h-7.1V10.67h7.1Z",
    transform: "translate(0)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1882",
    "data-name": "Rettangolo 1882",
    width: 14,
    height: 14,
    transform: "translate(1929 4263)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSkills);
export default __webpack_public_path__ + "static/media/view_skills.1ca1a1b039aa9c9aeb528c200228e520.svg";
export { ForwardRef as ReactComponent };